import { ocapiV1Routes } from '../routes';
const memberJourneysPrefix = `${ocapiV1Routes.currentMember}/journeys`;
const memberPaymentCardsPrefix = `${ocapiV1Routes.currentMember}/payment-cards`;
const memberSubscriptionsPrefix = `${ocapiV1Routes.currentMember}/subscriptions`;
const memberWatchlistFilmsPrefix = `${ocapiV1Routes.currentMember}/watchlist-films`;
const memberCredentialsPrefix = `${ocapiV1Routes.currentMember}/credentials`;
const memberFriendsPrefix = `${ocapiV1Routes.currentMember}/friends`;
export const loyaltyApiRoutes = {
    masterData: {
        get: ()=>`${ocapiV1Routes.prefix}/loyalty-master-data`
    },
    members: {
        create: ()=>ocapiV1Routes.members
        ,
        getCurrent: ()=>ocapiV1Routes.currentMember
        ,
        validateEmailAvailability: ()=>`${ocapiV1Routes.members}/email-availability`
        ,
        authentication: {
            createToken: ()=>`${ocapiV1Routes.members}/authentication-token`
            ,
            createCookie: ()=>`${ocapiV1Routes.members}/authentication-cookie`
            ,
            expireCookie: ()=>`${ocapiV1Routes.members}/authentication-cookie`
        },
        friends: {
            createCode: ()=>`${ocapiV1Routes.currentMember}/friend-code`
            ,
            addFromCode: ()=>`${memberFriendsPrefix}/code`
            ,
            remove: (friendId)=>`${memberFriendsPrefix}/${friendId}`
            ,
            setSubscriptionSharing: (friendId)=>`${memberFriendsPrefix}/${friendId}/subscription-sharing`
        },
        journeys: {
            getCurrent: ()=>`${memberJourneysPrefix}/current`
            ,
            getPast: ()=>`${memberJourneysPrefix}/past`
        },
        passwordReset: {
            createCode: ()=>`${ocapiV1Routes.members}/password-reset-code`
            ,
            validateCode: ()=>`${ocapiV1Routes.members}/password-reset-code/validate`
            ,
            reset: ()=>`${ocapiV1Routes.members}/password-reset`
        },
        paymentCards: {
            getAll: ()=>memberPaymentCardsPrefix
            ,
            getById: (memberPaymentCardId)=>`${memberPaymentCardsPrefix}/${memberPaymentCardId}`
            ,
            remove: (memberPaymentCardId)=>`${memberPaymentCardsPrefix}/${memberPaymentCardId}`
            ,
            setPrimary: ()=>`${memberPaymentCardsPrefix}/primary`
            ,
            createEmbedded: ()=>`${memberPaymentCardsPrefix}/embedded`
        },
        rewards: {
            getAll: ()=>`${ocapiV1Routes.currentMember}/rewards`
        },
        subscriptions: {
            setVistaAsSubscriptionPaymentProvider: ()=>`${memberSubscriptionsPrefix}/current/billing/payment-provider/vista`
            ,
            setFutureRecurring: ()=>`${memberSubscriptionsPrefix}/future-recurring`
            ,
            reactivateCurrent: ()=>`${memberSubscriptionsPrefix}/current/reactivate`
            ,
            cancelCurrent: ()=>`${memberSubscriptionsPrefix}/current`
        },
        ticketRedemptionCards: {
            getAll: ()=>`${ocapiV1Routes.currentMember}/ticket-redemption-cards`
        },
        transactions: {
            get: ()=>`${ocapiV1Routes.currentMember}/transactions`
        },
        update: {
            setPersonalDetails: ()=>`${ocapiV1Routes.currentMember}/personal-details`
            ,
            setEmail: ()=>`${memberCredentialsPrefix}/email`
            ,
            setPassword: ()=>`${memberCredentialsPrefix}/password`
            ,
            setUsername: ()=>`${memberCredentialsPrefix}/username`
            ,
            setPhoto: ()=>`${ocapiV1Routes.currentMember}/photo`
        },
        watchedFilms: {
            get: ()=>`${ocapiV1Routes.currentMember}/watched-films`
        },
        watchlistFilms: {
            getAll: ()=>memberWatchlistFilmsPrefix
            ,
            add: ()=>memberWatchlistFilmsPrefix
            ,
            remove: (filmId)=>`${memberWatchlistFilmsPrefix}/${filmId}`
        }
    }
};

//# sourceMappingURL=routes.js.map